<template lang="pug">
    layout

        // Main title
        title-component(
            slot="title"
            type="h2"
            :title="$t('managers.edit.title')"
        )

        v-container.grid-list-lg(fluid)
            v-layout(raw wrap)
                v-flex(xs12 md6)
                    div.padderRight.mb-3
                        div.pb-2

                            // Form title
                            title-component(type="h4" :title="$t('managers.create.subtitle')")

                        // Edit form
                        edit-form(ref="form")

                v-flex(xs12 md6)
                    div.padderLeft.mb-3
                        title-component(type="h4" :title="$t('managers.edit.settings.title')")

                        //Account settings
                        account-settings

                        // Horizontal line
                        separator-component

                        div(v-if="managerRole === 'instructor'")
                            title-component(type="h4" :title="$t('managers.edit.settings.uploadTitle')")

                            //Upload Avatar
                            upload-component(:userId="id")


                v-flex(xs12)

                    // Horizontal line
                    separator-component

                    div.controls

                        div

                            // Cancel button
                            button-component.ml-0(
                                :action="cancel"
                                :isLoading="isLoading"
                                color="grey"
                                large
                                outline
                            ) {{ $t('defaultButtons.cancel') }}

                        div

                            // Submit button
                            button-component.mr-0.submit(
                                color="primary"
                                :action="submit"
                                :isLoading="isLoading"
                                large
                            ) {{ $t('defaultButtons.save') }}

</template>

<script>
    import Layout from '../../Layout/Layout';
    import AccountSettings from './AccountSettings';
    import EditForm from './EditForm';
    import VueTypes from 'vue-types';
    import Button from '~components/Button';
    import Separator from '~components/Separator';
    import Title from '~components/Title';
    import { mapActions, mapGetters } from 'vuex';
    import AvatarUpload from '~components/AvatarUpload';

    export default {
        components: {
            Layout,
            AccountSettings,
            EditForm,
            ButtonComponent: Button,
            SeparatorComponent: Separator,
            TitleComponent: Title,
            UploadComponent: AvatarUpload
        },
        props: {
            id: VueTypes.string.def('')
        },
        computed: {
            ...mapGetters('managers', ['isLoading', 'managerRole'])
        },
        beforeMount() {
            this.read(this.id);
        },
        methods: {
            ...mapActions('managers', ['read', 'cancel']),

            /**
             * Update manager account
             */
            submit() {
                this.$refs.form.submitForm();
            }
        }
    };
</script>

<style lang="stylus" scoped>
    @import '../../../../assets/style/_variables.styl'

    @media screen and (min-width: $grid-breakpoints.md)
        .padderRight
            padding-right: 20px

        .padderLeft
            padding-left: 20px
</style>
